import * as React from "react";
import { useEffect, useState } from "react";
import { FormGroup } from "../RightAsideHelpers";
import Select from "@/components/Select";
import useApi from "@/hooks/useApi";
import { WorkflowNode } from "../../types";

interface WorkflowListItem {
  id: number;
  name: string;
}

interface Props {
  node: WorkflowNode;
  onUpdate: (node: Partial<WorkflowNode>) => void;
}

export default function CallWorkflowEditor({ node, onUpdate }: Props) {
  const api = useApi();
  const [workflows, setWorkflows] = useState<WorkflowListItem[]>([]);

  useEffect(() => {
    async function load() {
      try {
        const resp = await api.messaging.get("Workflows/List");
        const data = await resp.json();
        setWorkflows(Array.isArray(data) ? data : []);
      } catch {
        setWorkflows([]);
      }
    }
    load();
  }, []);

  const options: Record<number, string> = {};
  for (const w of workflows) {
    options[w.id] = w.name;
  }

  return (
    <>
      <FormGroup
        label="Workflow to call"
        tooltipText="Select a workflow to run as a sub-workflow at this point. Its nodes will execute inline, then this workflow continues to the next step."
      >
        <Select
          options={options}
          value={node.referencedWorkflowId}
          onChange={(value) => onUpdate({ referencedWorkflowId: value })}
        />
      </FormGroup>
      <div className="px-1 py-2 text-xs text-slate-400 leading-snug">
        The called workflow runs within this job&apos;s step budget. Interactive nodes
        (Ask Question, Time Delay, Request Payment) inside a called workflow are skipped.
        Each invocation counts as one additional workflow run.
      </div>
    </>
  );
}
